<template>
  <div class="btn-create">
    <Dropdown :hideArrow="true" ref="moreActionCreate" lclass="btn-create-dropdown" bclass="btn-primary btn-default btn-lg">
      <template v-slot:button>
        <span class="mr-1">
          <i class="icon icon-plus typo-icon-12"></i>
        </span>
        {{ $t("analytic.ab.createNewCamp") }}
      </template>
      <div class="gp_dropdown-item btn-create-item" @click="itemCreateClick(addPages)">
        <div class="text-content text-left">
          <h2 class="typo-heading16 typo-medium text-light-high mb-1">{{ $t("page.btnCreate.fromPages") }}</h2>
          <p class="typo-paragraph12 typo-regular-150 text-light-low">{{ $t("page.btnCreate.fromPagesDesc") }}</p>
        </div>
      </div>
      <div class="gp_dropdown-item btn-create-item" @click="itemCreateClick(templatePage)">
        <div class="text-content text-left">
          <h2 class="typo-heading16 typo-medium text-light-high mb-1">{{ $t("page.btnCreate.newPage") }}</h2>
          <p class="typo-paragraph12 typo-regular-150 text-light-low">{{ $t("page.btnCreate.newPageDesc") }}</p>
        </div>
      </div>
    </Dropdown>
  </div>
</template>

<script>
export default {
  name: "ButtonCreateCampaign",
  props: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    itemCreateClick(fn) {
      if (this.$refs.moreActionCreate) {
        this.$refs.moreActionCreate.toggleDropdown();
      }
      if (fn) fn();
    },
    templatePage() {
      this.$emit("onClickTemplatePage");
    },
    addPages() {
      this.$emit("onClickAddPages");
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-create {
  @include trans-all;
  display: inline-flex;
  ::v-deep .btn-create-dropdown {
    width: 280px;
    right: 0;
    border: none;

    .btn-create-item {
      padding: 16px 24px;
      display: flex;
      border: none !important;

      &:hover {
        @include trans-all;
        svg {
          fill: $cPrimary;
        }
        .text-content {
          p:last-child {
            color: $black1;
          }
        }
      }

      .text-content {
        flex: 1;
        p:not(:last-child) {
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>
